import React from 'react';
// import '../styles/About.css';
import Etv from '../components/Etv';

function EtvMain() {
    return (
        <div id="top" className="about-top">



            <Etv id="etv" />


        </div>

    );
}

export default EtvMain;
